export default {
	ADDRESS: 'address',
	FIRST_NAME: 'firstname',
	LAST_NAME: 'lastname',
	EMAIL: 'email',
	PHONE: 'phone'
};
